module.exports = __webpack_public_path__ + "img/jf.9814a692.png";